import { render, staticRenderFns } from "./UserRecents.vue?vue&type=template&id=44723ab9"
import script from "./UserRecents.vue?vue&type=script&lang=ts"
export * from "./UserRecents.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports